import { SelectOption } from '@components/StatefulInputs/StatefulSelect/StatefulSelect.types';
import { STATES } from '@utilities/STATES';

export const ADDRESS_STATE_OPTIONS: SelectOption[] = STATES.map((value) => ({
	value: value,
	label: value,
}));
